import classNames from 'classnames';

import styles from './Label.module.scss';

export const Label = ({ children, className, unstyled = false, ...props }) => (
  <label {...props} className={unstyled ? className : classNames(styles.container, className)}>
    {children}
  </label>
);
